module.exports = __webpack_public_path__ + "img/0-34.cc76fab7.jpg";